<div class="wrapper">
  <header class="pageHeader">
    <div class="pageHeading"><span class="pageIcon"><mat-icon>person</mat-icon></span><h1>{{ client ? (client.name || 'Клиент без имени') : 'Карточка клиента' }}</h1><span class="countBadge" *ngIf="client">№{{ client.id }}</span></div>
    <div class="headerActions"><a mat-stroked-button routerLink="/catalogue/clients" [queryParams]="returnFilters"><mat-icon>arrow_back</mat-icon> К клиентам</a><a *ngIf="client" mat-stroked-button routerLink="/parts-selection/new" [queryParams]="{client_id: client.id}"><mat-icon>assignment</mat-icon> Подбор</a><a *ngIf="client" mat-flat-button color="primary" routerLink="/orders/create" [queryParams]="{client_id: client.id}"><mat-icon>add_shopping_cart</mat-icon> Новый заказ</a></div>
  </header>
  <div class="profileState" *ngIf="loading" role="status"><mat-progress-bar mode="indeterminate"></mat-progress-bar><span>Загрузка карточки клиента…</span></div>
  <div class="profileState errorState" *ngIf="error" role="alert"><mat-icon>error_outline</mat-icon><p>{{ error }}</p><button mat-stroked-button (click)="load()">Повторить</button></div>
  <div class="profileGrid" *ngIf="client">
    <section class="workspaceColumn" aria-label="Работа с клиентом">
      <mat-tab-group class="workspaceTabs" animationDuration="0ms" [preserveContent]="true" [selectedIndex]="selectedTab" (selectedIndexChange)="selectTab($event)">
        <mat-tab>
          <ng-template mat-tab-label
            ><mat-icon>receipt_long</mat-icon><span>Заказы</span></ng-template
          >
          <div class="workspacePane orders">
            <app-order-list context="client" [clientId]="client?.id ?? null"></app-order-list>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>directions_car</mat-icon><span>Автомобили</span>
            <span class="tabCount" *ngIf="client?.cars?.length">{{ client?.cars?.length }}</span>
          </ng-template>
          <ng-template matTabContent><div class="workspacePane"><app-cars [client]="client"></app-cars></div></ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>percent</mat-icon><span>Наценка</span></ng-template>
          <ng-template matTabContent><div class="workspacePane">
            <app-client-markup-table [client]="client" layout="table"></app-client-markup-table>
          </div></ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>call</mat-icon><span>Звонки</span></ng-template>
          <ng-template matTabContent>
            <div class="workspacePane">
              <app-client-call-history [client]="client"></app-client-call-history>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>analytics</mat-icon><span>Отчёты</span></ng-template>
          <ng-template matTabContent><div class="workspacePane">
            <app-client-reports [client]="client"></app-client-reports>
          </div></ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>account_balance_wallet</mat-icon><span>Взаиморасчёты</span></ng-template>
          <ng-template matTabContent><div class="workspacePane settlements">
            <app-customer-account [clientId]="client.id" [clientName]="client.name" [(orgId)]="accountOrgId"></app-customer-account>
          </div></ng-template>
        </mat-tab>
      </mat-tab-group>
    </section>
    <aside class="sidebarColumn" aria-label="Основная информация о клиенте">
      <app-customer-account class="clientAccountSummary" [clientId]="client.id" [clientName]="client.name" [compact]="true" [(orgId)]="accountOrgId"></app-customer-account>
      <details class="clientInfoDisclosure" [open]="!mobileLayout">
        <summary><mat-icon aria-hidden="true">person</mat-icon><span>{{ client?.name || 'Клиент' }} {{ client?.surname }}</span><mat-icon class="disclosureChevron" aria-hidden="true">expand_more</mat-icon></summary>
        <app-main-info [client]="client" (clientChanged)="client = $event"></app-main-info>
      </details>
    </aside>
  </div>
</div>
